export const notificationsApiAvailable = () => 'Notification' in window;

export const permissionGranted = () => Notification?.permission === 'granted';

export const appHidden = () => document.visibilityState === 'hidden';
